import * as actionTypes from '../action-types';
import { WatcherEntityItem } from '../../watchers.types';
import { UserWatchersActions } from '../actions';

const defaultState: { [uniqueId: string]: WatcherEntityItem } = {};

export function userWatchersMapReducer(
  state = defaultState,
  action: UserWatchersActions,
) {
  switch (action.type) {
    case actionTypes.SET_USER_WATCHERS: {
      const { watchers } = action.payload;
      return watchers.reduce(
        (acc: { [uniqueId: string]: WatcherEntityItem }, item) => {
          acc[item.uniqueId] = item;
          return acc;
        },
        {},
      );
    }
    case actionTypes.SET_USER_WATCHER: {
      const { watcher } = action.payload;
      return { ...state, [watcher.uniqueId]: watcher };
    }
    case actionTypes.UNSET_USER_WATCHER: {
      const { watcher } = action.payload;
      const { [watcher.uniqueId]: removed, ...rest } = state;
      return rest;
    }
    default: {
      return state;
    }
  }
}
